/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import React from "react";

type Props = {
  iconColor: string;
  isEmptyCart: boolean;
  onClick: () => void;
};

export const HeaderCartButton: React.FC<Props> = (props) => {
  const styles = headerCartButtonStyles(props.iconColor);

  return (
    <div>
      <button
        id="cart"
        type="button"
        aria-label="Cart"
        css={[styles.button, !props.isEmptyCart && styles.badgeButton]}
        onClick={props.onClick}
      >
        <ShoppingCartIcon />
        <span aria-hidden="true"></span>
      </button>
    </div>
  );
};

const headerCartButtonStyles = (iconColor: string) => {
  return {
    button: css({
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer",
      svg: {
        fill: iconColor,
        cursor: "pointer",
      },
    }),
    badgeButton: css({
      position: "relative",
      span: {
        position: "absolute",
        top: 0,
        right: 0,
        width: 10,
        height: 10,
        backgroundColor: "#f00",
        border: "1px solid #fff",
        borderRadius: "50%",
      },
    }),
  };
};
